import React, { useState } from 'react'
import { useEffect, useRef } from 'react'

export default function Skills() {
    const [skills, useskills] = useState(['C++', 'C', 'Java', 'Python', 'HTML', 'CSS', 'Git', 'Markdown', 'React.js', 'Node.js', 'MySQL']);
    const [counter, setcounter] = useState(0);
    const len = skills.length;

    useEffect(() => {
        
        const intervalId = setInterval(function(){
            setcounter(counter => (counter+1) % len);
        }, 5000);
        
        return () => clearInterval(intervalId);
    }, [])
  
    return (
        <div id="skills" className="bg-black-400 pb-40 z-10 mt-20 pt-10">
                <div className="w-11/12 max-w-5xl m-auto relative">
                    <h1 className="text-center text-4xl lg:text-5xl text-green-300 font-mono lg:text-right mb-10 font-black">Skills</h1>

                    <div className="flex md:flex-row flex-col-reverse items-center mt-20 justify-between">
                        <div className="bg-black-300 rounded-lg md:w-7/12 w-11/12">
                            <p className="text-black-100 text-xl md:max-w-prose p-6">I spent most of my time writing <span className="text-green-100 font-mono">C/C++</span> codes because I appreciate their speed and efficiency. Apart from those I also use <span className="text-green-100 font-mono">Python</span>, <span className="text-green-100 font-mono">Java</span>, and also write code for the web using <span className="text-green-100 font-mono">JavaScript</span>. Being a visual person, I prefer the frontend part of the web and use <span className="text-green-100 font-mono">React.js</span> most of the time, but I also appreciate the flexibilty that <span className="text-green-100 font-mono">Node.js</span> provides to build a personal backend from scratch.</p>

                            <p className="text-black-100 text-xl max-w-prose p-6">My other specialities include learning a new skill pretty quickly, programming languages and problem-solving.</p>
                        </div>
                        <div className="w-5/12">
                            <div className="scene mt-0 mb-20  md:m-auto">
                                <div className="cube">
                                    <div className="text-green-300 font-black text-4xl cube__face cube__face--front bg-black-300 opacity-70 border border-violet-200">{skills[(counter+3) % len]}</div>
                                    <div className="text-green-300 font-black text-4xl cube__face cube__face--back bg-black-300 opacity-70 border border-violet-200">{skills[(counter+2)%len]}</div>
                                    <div className="text-green-300 font-black text-4xl cube__face cube__face--right bg-black-300 opacity-70 border border-violet-200">{skills[(counter+1)%len]}</div>
                                    <div className="text-green-300 font-black text-4xl cube__face cube__face--left bg-black-300 opacity-70 border border-violet-200">{skills[(counter)%len]}</div>
                                    <div className="cube__face cube__face--top bg-black-300 opacity-70 border border-violet-200"></div>
                                    <div className="cube__face cube__face--bottom bg-black-300 opacity-70 border border-violet-200"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            
        </div>
    )
}
